import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PublicationSelection } from '@models/configuration/rules/publication-selection-model';

export interface SelectionSelectModalData {
  selections: PublicationSelection[];
  selectedIds: number[];
}

@Component({
  selector: 'app-selection-select-modal',
  templateUrl: './selection-select-modal.component.html',
  styleUrls: ['./selection-select-modal.component.scss'],
})
export class SelectionSelectModalComponent {
  selectedIds: Set<number>;

  constructor(
    public dialogRef: MatDialogRef<SelectionSelectModalComponent, number[]>,
    @Inject(MAT_DIALOG_DATA) public data: SelectionSelectModalData
  ) {
    this.selectedIds = new Set(data.selectedIds || []);
  }

  isSelected(id: number): boolean {
    return this.selectedIds.has(id);
  }

  toggle(id: number, checked: boolean) {
    if (checked) {
      this.selectedIds.add(id);
    } else {
      this.selectedIds.delete(id);
    }
  }

  selectAll() {
    (this.data.selections || []).forEach((s) => this.selectedIds.add(s.id));
  }

  clearAll() {
    this.selectedIds.clear();
  }

  confirm() {
    this.dialogRef.close(Array.from(this.selectedIds));
  }
}
